import { createContext, useContext } from 'react';

const DesktopPropertyHeaderPortalContext = createContext<HTMLElement | null>(null);

export const DesktopPropertyHeaderPortalProvider = DesktopPropertyHeaderPortalContext.Provider;

export const useDesktopPropertyHeaderPortalContainer = () => useContext(DesktopPropertyHeaderPortalContext);
